import domains from './config-environment';

const env = process.env.VUE_APP_ENV,
	region = environment.region,
	currentDomain = domains[env][region];

export default {
	domain: currentDomain,
	myAccount: {
		global: [
			{
				name: 'buyNx',
				url: '/wallet/add-balance',
			},
			{
				name: 'reviewPurchase',
				url: '/wallet/history',
			},
			{
				name: 'accountSetting',
				url: '/account/setting',
			},
			{
				name: 'logout',
				url: '/account/logout',
			},
		],
		one: [
			{
				name: 'addBalance',
				url: '/wallet/add-balance',
			},
			{
				name: 'reviewPurchase',
				url: '/wallet/history',
			},
			{
				name: 'accountSetting',
				url: '/account/setting',
			},
			{
				name: 'logout',
				url: '/account/logout',
			},
		],
		th: [
			{
				name: 'addBalance',
				url: '/wallet/add-balance',
			},
			{
				name: 'reviewPurchase',
				url: '/wallet/history',
			},
			{
				name: 'accountSetting',
				url: '/account/setting',
			},
			{
				name: 'logout',
				url: '/account/logout',
			},
		],
		tw: [
			{
				name: 'addBalance',
				url: '/wallet/add-balance',
			},
			{
				name: 'reviewPurchase',
				url: '/wallet/history',
			},
			{
				name: 'accountSetting',
				url: '/account/setting',
			},
			{
				name: 'logout',
				url: '/account/logout',
			},
		],
		sea: [
			{
				name: 'addBalance',
				url: '/wallet/add-balance',
			},
			{
				name: 'reviewPurchase',
				url: '/wallet/history',
			},
			{
				name: 'accountSetting',
				url: '/account/setting',
			},
			{
				name: 'logout',
				url: '/account/logout',
			},
		],
		japan: [
			{
				name: 'addBalance',
				url: '/wallet/add-balance',
				hidden: true,
			},
			{
				name: 'reviewPurchase',
				url: '/wallet/history',
				hidden: true,
			},
			{
				name: 'accountSetting',
				url: '/account/setting',
			},
			{
				name: 'logout',
				url: '/account/logout',
			},
		],
	},
	supportLinks: {
		global: 'https://playersupport.nexon.com/',
		one: 'https://playersupport.nexon.com/',
		th: '/help/home',
		tw: '/help/home',
		sea: '/help/home',
		vietnam: '/help/vi',
		japan: 'https://japan.nexon.com/help/ja',
	},
};
